import { render, staticRenderFns } from "./CamaraVODPantalla.vue?vue&type=template&id=7d31c2c4&scoped=true&"
import script from "./CamaraVODPantalla.vue?vue&type=script&lang=ts&"
export * from "./CamaraVODPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d31c2c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7d31c2c4', component.options)
    } else {
      api.reload('7d31c2c4', component.options)
    }
    module.hot.accept("./CamaraVODPantalla.vue?vue&type=template&id=7d31c2c4&scoped=true&", function () {
      api.rerender('7d31c2c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/VOD/CamaraVODPantalla.vue"
export default component.exports